<template>
  <v-sheet>
    <AppBar />
    <AlertModal />

    <NavigationDrawer
      v-if="isLoggedIn && activeUrl !== '/'"
      :active-url="activeUrl"
    />

    <FilterDrawer v-if="activeUrl === '/'" />
  </v-sheet>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Navigation",
  props: {
    activeUrl: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters("Auth", ["isLoggedIn"])
  }
};
</script>

<style></style>
